import { useEffect, useMemo, useState } from "react";
//--------------------------------------------------------------------------------------------
import Modal from "src/components/common/modal";
import Esign from "src/components/common/esign";
import Esigns from "src/components/common/esigns";
import UserInfo from "src/components/common/userInfo";
import signimg from "src/img/jsa/essentialControls.png";
import mechanicalimg from "src/img/jsa/mechanical/mechanical.png";
import mechanical1img from "src/img/jsa/mechanical/mechanical1.png";
import gravity1img from "src/img/jsa/gravity/gravity1.png";
import gravity2img from "src/img/jsa/gravity/gravity2.png";
import gravityimg from "src/img/jsa/gravity/gravity.png";
import soundimg from "src/img/jsa/sound/sound.png";
import sound1img from "src/img/jsa/sound/sound1.png";
import temperatureimg from "src/img/jsa/temperature/temperature.png";
import temperature1img from "src/img/jsa/temperature/temperature1.png";
import temperature2img from "src/img/jsa/temperature/temperature2.png";
import temperature3img from "src/img/jsa/temperature/temperature3.png";
import pressureimg from "src/img/jsa/pressure/pressure.png";
import pressure1img from "src/img/jsa/pressure/pressure1.png";
import pressure2img from "src/img/jsa/pressure/pressure2.png";
import biologicalimg from "src/img/jsa/biological/biological.png";
import biological1img from "src/img/jsa/biological/biological1.png";
import electricalimg from "src/img/jsa/electrical/electrical.png";
import electrical1img from "src/img/jsa/electrical/electrical1.png";
import electrical2img from "src/img/jsa/electrical/electrical1.png";
import motionimg from "src/img/jsa/motion/motion.png";
import motion1img from "src/img/jsa/motion/motion1.png";
import motion2img from "src/img/jsa/motion/motion2.png";
import chemicalRadiationimg from "src/img/jsa/chemicalRadiation/chemicalRadiation.png";
import chemicalRadiation1img from "src/img/jsa/chemicalRadiation/chemicalRadiation1.png";
import { useMyStore } from "src/components/main/mainStore";
import {
    myAxios, 
    MyFormData, 
    MyDate, 
    OtherStyle, 
    onlyUnique, 
    jsaManagers, 
    jsaOnsiteNumbers,
    arrayReducer, 
    defaultEmptyDateTime, 
} from "src/components/common/functions";
//--------------------------------------------------------------------------------------------
export default function JSAItem({
    formTitle, 
    jobSafetyAnalysisContent, 
    setWorkLogs, 
    setWorkInstructions, 
    closeIt, 
    /*---- workInstruction ----------------------------------------*/
    workInstructionHashKey, 
    location, 
    /*---- workLog ------------------------------------------------*/
    workLogHashKey, 
    projectName, 
    nearestMedicalFacility, 
    /*---- admin --------------------------------------------------*/
    adminLink, 
    /*-------------------------------------------------------------*/
    /*---- multiSite only -----------------------------------------*/
    mainLaborCategory, 
    setMainLaborCategory, 
    mainLaborName, 
    setMainLaborName, 
    helpers, 
    setHelpers, 
    formWorkLogHashKey, 
    formHashKey, //uid
    /*---- main only ----------------------------------------------*/
    userName, 
    laborCategory, 
}){
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const user = useMyStore(state => state.user);
    /*-------------------------------------------------------------*/
    // signs
    const [internalPicDatas, setInternalPicDatas] = useState([]);
    const [picDatas, setPicDatas] = useState([]);
    const [picData, setPicData] = useState([]);
    /*-------------------------------------------------------------*/
    // constant
    const sifList = [
        {title: "Mechanical", img: mechanicalimg, options: [
            {title: "Heavy Rotating Equipment", img: mechanical1img, options: [
                "Physical barrier", 
                "Machine guards", 
                "2-hand switches", 
                "Automatic shut-off", 
                "Machines with sensing devices / auto-shutoff", 
                "Hair net", 
                "Safe Hand \"hand-free\" push, pull, grab tool", 
                "Tear-away finger gloves", 
                "Lock-out tag-out", 
                "Area curtains", 
                "Eye protection", 
            ]}, 
        ]}, 
        {title: "Gravity", img: gravityimg, options: [
            {title: "Suspended Load / Dropped Objects", img: gravity1img, options: [
                "Rated rigging equipment and attachment points", 
                "Load limiting devices", 
                "Hoist break", 
                "Tool tethers", 
                "Drop nets", 
                "Crawl speed on the hoist", 
                "Boom angle sensors / limiters",
                "Double rigging / redundancy",
                "Tag line retriever / Safe hand tool", 
                "Drop Zone Physical Barriers / Exclusion Zone", 
                
            ]}, 
            {title: "Fall from Elevation", img: gravity2img, options: [
                "Fall arrest system", 
                "Self-restracting lifeline", 
                "Work positioning device / restraint", 
                "Guard rails", 
                "Covers over holes / trench plates", 
                "Drop Zone Physical Barriers / Exclusion Zone", 
                
            ]}, 
        ]}, 
        {title: "Sound", img: soundimg, options: [
            {title: "Deciblel levels where permanent hearing loss can occur", img: sound1img, options: [
                "Hearing protection", 
                "Sound insulation", 
                "Rubber vibration damping", 
            ]}, 
        ]}, 
        {title: "Temperature", img: temperatureimg, options: [
            {title: "Surface Temperature", img: temperature1img, options: [
                "Physical Barriers", 
                "Lock-out tag-out", 
                "Surface insulation", 
                "De-energization with zero voltage test", 
                "Tool that forces safe distance / MAD", 
                "Heat-resistant clothing / thermal suits / Kevlar sleeves", 
                "Active cooling system", 
            ]}, 
            {title: "Steam", img: temperature2img, options: [
                "Physical Barriers", 
                "Lock-out tag-out", 
                "Tool that forces safe distance / MAD", 
                "Heat-resistant clothing / thermal suits / Kevlar sleeves", 
                "Pressure release valve", 
                "Flash-rated suit, glasses, face shield", 
                "Fire-resistant (FR) clothing", 
                "Remote racking devices", 
                "Flash protection boundary with hard physical barriers", 
                "Hot line sticks", 
            ]}, 
            {title: "Fire with Sustained Fuel Source", img: temperature3img, options: [
                "Lock-out tag-out", 
                "Surface insulation", 
                "Heat-resistant clothing / thermal suits / Kevlar sleeves", 
                "Fire protection system", 
                "Remote fuel shut off", 
                "Fire extinguisher / suppression", 
                "Gas detection monitoring", 
                "Sprinkler system", 
                "Self-contained breathing apparatus", 
                "Steam suits", 
                "Fire-resistant (FR) clothing", 
            ]}, 
        ]}, 
        {title: "Pressure", img: pressureimg, options: [
            {title: "Explosion / pressurized Projectiles", img: pressure1img, options: [
                "Physical barrier / Blast shield", 
                "Lock-out tag-out", 
                "Explosive ordinance disposal (EOD) suit", 
                "Rupture discs", 
                "Relef valve", 
                "Whip restraint", 
                "Inerting to exclude O2", 
                "Pressure indicators with auto shutoff", 
                "Fuel source separation", 
                "Motor control center (MCC) panel enclosure", 
                "Coupler lock", 
                "Explosion suppression system", 
            ]}, 
            {title: "Excavation or Trench", img: pressure2img, options: [
                "Hard physical barrier", 
                "Covers over holes / trenches", 
                "Sloping and benching", 
                "Trench box", 
                "Excavation support system", 
            ]}, 
        ]}, 
        {title: "Biological", img: biologicalimg, options: [
            {title: "Life-Threatening Animal & Insect Attack, Sewage", img: biological1img, options: [
                "Snake Gaiter Leg Guards", 
                "Dog Bite Stick", 
                "Respirator", 
            ]}, 
        ]}, 
        {title: "Electrical", img: electricalimg, options: [
            {title: "Electrical Contact with High Energy Source", img: electrical1img, options: [
                "Cover up", 
                "Lock-out tag-out", 
                "Tool that forces MAD safe distance", 
                "De-energization with zero voltage test", 
                "Grounding", 
                "Insulating barriers", 
                "Insulating nonconductive PPE gloves, sleeves, shoes, etc.", 
                "Electrical hazard / dielectric footwear", 
                "Ground fault circuit interrupters", 
                "Hot line sticks", 
                "Remote racking devices", 
                "Equipotential zones", 
                "Insulated and / or voltage-rated euipment and tools", 
                "Physical Barriers / Exclusion Zone"
            ]}, 
            {title: "Arc Flash", img: electrical2img, options: [
                "Lock out tag-out", 
                "Tool that forces MAD safe distance", 
                "Motor control center (MCC) panel enclosure", 
                "De-energization with zero voltage test", 
                "Insulating PPE gloves, sleeves, shoes, etc.", 
                "Flash-rated suit, glasses, face shield", 
                "Fire-resistant (FR) clothing", 
                "Remote racking devices", 
                "Flash protection boundary with hard physical barriers", 
                "Hot line sticks", 
            ]}, 
        ]}, 
        {title: "Motion", img: motionimg, options: [
            {title: "Mobile Equipment / Traffic with Workers on Foot", img: motion1img, options: [
                "Walkway / worker on foot physical barriers exclusion zone",
                "Traffic control zone with physical barriers", 
                "Mobile equipment ignition lock-out Tag-out", 
            ]}, 
            {title: "ATV / OUV (occupant)", img: motion2img, options: [
                "Rollover protection system", 
                "Seat belt", 
                "DOT Helmet", 
                "Speed governor key", 
            ]}, 
        ]}, 
        {title: "Chemical / Radiation", img: chemicalRadiationimg, options: [
            {title: "High Dose of Toxic Chemical or Radiation", img: chemicalRadiation1img, options: [
                "Lock-out tag-out", 
                "Local ventilation", 
                "Respirator", 
                "Radiation shielding", 
                "Chemical suit and gloves", 
            ]},  
        ]}, 
    ];
    const hazardControlData = [
        "Slips / Trips / Falls", 
        "Driving", 
        "Flammable", 
        "Combustible", 
        "Chemical", 
        "Temp: Heat / Cold", 
        "Noise", 
        "Electrical", 
        "Pinch Points", 
        "Weather", 
        "Uneven Surface", 
        "Vac Truck Boom", 
        "Open Utility Manhole", 
        "Open Pothole", 
        "Open Trench", 
        "Moving Equipment", 
        "Backing up Vehicles", 
        "Flying Debris", 
        "Air/hydro Lance & Nosel", 
        "Vacuum Hose", 
        "Air Tools", 
        "Hand Saws", 
        "Core Drills", 
        "Animals"
    ];
    const confinedSpaceHotWork = [
        "Does Task Present Confined Space Hazards?", 
        "Do We need air Monitoring?", 
        "Will there be Hot Work?", 
        "Do we need a permit?", 
        "Is Fire Watch required?", 
        "Are respirators needed?", 
        "Do we need attendant?"
    ];
    const confinedSpaceHotWorkNames = [
        "confinedSpaceHazard", 
        "airMonitoring", 
        "hotWork",   
        "permit", 
        "fireWatch", 
        "respirators", 
        "attendant"
    ];
    //-------------------------------------------------------------------------------------------
    // dynamic module
    const [hazardControls, setHazardControls] = useState(jobSafetyAnalysisContent.hazardControls?
        JSON.parse(jobSafetyAnalysisContent.hazardControls || "[]"):[]
    );
    const defaultSIF = Object.fromEntries(sifList.map(sif => [sif.title, {
        selected: false, 
        inputHazard: "", 
        inputControls: "", 
        content: Object.fromEntries(
            sif.options.map(hazard => [hazard.title, []])
        )
    }]));
    const [sif, setSIF] = useState(jobSafetyAnalysisContent.sif?
        JSON.parse(jobSafetyAnalysisContent.sif || JSON.stringify(defaultSIF)):defaultSIF
    );
    /*-------------------------------------------------------------*/
    // others module
    const [others, setOthers] = useState(jobSafetyAnalysisContent.others?
        JSON.parse(jobSafetyAnalysisContent.others || "{}"):{}
    );
    //-------------------------------------------------------------------------------------------
    const realTime = useMemo(() => `${(new MyDate()).s()} ${(new MyDate()).ss()}`, []);
    //-------------------------------------------------------------------------------------------
    const curContent = jobSafetyAnalysisContent?jobSafetyAnalysisContent:{};
    /*-------------------------------------------------------------*/
    // content
    const [curSel1, setCurSel1] = useState(curContent.sel1 ?? "");
    const [curConfinedWork, setConfinedWork] = useState(curContent.sel3 ?? "");
    const [ppe, setPPE] = useState(false);
    //-------------------------------------------------------------------------------------------
    const faceData = [
        "Safety Glasses", 
        "Chemical Goggles", 
        "Impact Goggles", 
        "Full Face shield", 
        "Cutting goggles"
    ];
    const [eyeFace, setEyeFace] = useState(curContent.eyeFace?
        (Array.isArray(curContent.eyeFace)?curContent.eyeFace:curContent.eyeFace.split(", "))
        .filter(eyeFaceItem => faceData.includes(eyeFaceItem)):[]);
    const handData = [
        "Cloth", 
        "Leather", 
        "Welding", 
        "Metal mesh", 
        "Electriacl Insulated", 
        "Rubber", 
        "Kevlar", 
        "Latex", 
        "Vinyl", 
        "Butyl", 
        "Nitrile"
    ];
    const [handGloves, setHandGloves] = useState(curContent.handGloves?
        (Array.isArray(curContent.handGloves)?curContent.handGloves:curContent.handGloves.split(", "))
        .filter(handGlovesItem => handData.includes(handGlovesItem)):[]);
    const footData = [
        "Hard toe shoes / boots", 
        "Dielectric", 
        "Neoprene", 
        "Rubber", 
        "PVC / Urethane", 
        "Metatarsul guard"
    ];
    const [foot, setFoot] = useState(curContent.foot?
        (Array.isArray(curContent.foot)?curContent.foot:curContent.foot.split(", "))
        .filter(footItem => footData.includes(footItem)):[]);
    const headData = [
        "Class 'E' Hard hat ANSI Z89.1,2009 TYPE I"
    ];
    const [head, setHead] = useState(curContent.head?
        (Array.isArray(curContent.head)?curContent.head:curContent.head.split(", "))
        .filter(headItem => headData.includes(headItem)):[]);
    const gasDetectorData = [
        "Multi Gas Detector", 
        "H2S Gas Monitor Test daily"
    ];
    const [gasDetector, setGasDetector] = useState(curContent.gasDetector?
        (Array.isArray(curContent.gasDetector)?curContent.gasDetector:curContent.gasDetector.split(", "))
        .filter(gasDetectorItem => gasDetectorData.includes(gasDetectorItem)):[]);
    const respiratoryProtectionData =  [
        "Dust mask", "Fume / mist mask", 
        "Half face filter", 
        "Full face filter", 
        "Full face airline", "Half face SCBA", 
        "Emergency escape pack", "N95 mask"
    ];
    const [respiratoryProtection, setRespiratoryProtection] = useState(curContent.respiratoryProtection?
        (Array.isArray(curContent.respiratoryProtection)?curContent.respiratoryProtection:curContent.respiratoryProtection.split(", "))
        .filter(respiratoryProtectionItem => respiratoryProtectionData.includes(respiratoryProtectionItem)):[]);
    const protectiveClothingData = [
        "Nomex / FRC", 
        "Tyvek suits", 
        "Rain Suit", 
        "Acid Suit"
    ];
    const [protectiveClothing, setProtectiveClothing] = useState(curContent.protectiveClothing?
        (Array.isArray(curContent.protectiveClothing)?curContent.protectiveClothing:curContent.protectiveClothing.split(", "))
        .filter(protectiveClothingItem => protectiveClothingData.includes(protectiveClothingItem)):[]);
    const hearingData = [
        "Ear plugs", 
        "Canal cap", 
        "Ear muffs", 
        "Dual Protection"
    ];
    const [hearing, setHearing] = useState(curContent.hearing?
        (Array.isArray(curContent.hearing)?curContent.hearing:curContent.hearing.split(", "))
        .filter(hearingItem => hearingData.includes(hearingItem)):[]);
    const fallProtectionData = [
        "Fall Body Harness / 2 Lanyards", 
        "Static Line", 
        "Vertical Life Line"
    ];
    const [fallProtectionList, setFallProtectionList] = useState(curContent.fallProtectionList?
        (Array.isArray(curContent.fallProtectionList)?curContent.fallProtectionList:curContent.fallProtectionList.split(", "))
        .filter(fallProtection => fallProtectionData.includes(fallProtection)):[]);
    //--------------------------------------------------------------------------------------------
    const handleFormSubmit = async e => {
        e.preventDefault();
        Object.entries(sif).map(([key, val]) => {
            if(val.selected && (Object.values(val.content).reduce(arrayReducer, []).length === 0 && val.inputControls === "")){
              window.alert(`No control for ${key}.`);
              return;
            }
        });
        if(formHashKey){
            if(formWorkLogHashKey === workLogHashKey){
                if(!picData.length){
                    window.alert(mainLaborName + " need to sign.");
                    return;
                }
            }else{
                const sign = internalPicDatas.find(item => item.workLogHashKey === workLogHashKey);
                if(!sign.data.length){
                    window.alert(sign.laborName + " need to sign.");
                    return;
                }
            }
        }else{
            if(!picData.length){
                window.alert((userName || user.userName) + " need to sign.");
                return;
            }
        }
        const unsignedCostomer = picDatas.find(picDatas => !picDatas.data.length);
        if(unsignedCostomer){
            window.alert(unsignedCostomer.name + " need to sign.");
            return;
        }
        const formData = new MyFormData(e.currentTarget);
        formData.append("workLogHashKey", workLogHashKey);
        if(formHashKey) formData.append("formHashKey", formHashKey);
        formData.append("openDateTime", realTime); // google
        for(const eyeFaceItem of eyeFace){
            formData.append("eyeFace[]", eyeFaceItem);
        }
        // if(others[eyeFace + "Content"]){
        //     formData.append("eyeFace[]", others[eyeFace + "Content"]);
        // }
        for(const handGlovesItem of handGloves){
            formData.append("handGloves[]", handGlovesItem);
        }
        // if(others[handGloves + "Content"]){
        //     formData.append("handGloves[]", others[handGloves + "Content"]);
        // }
        for(const footItem of foot){
            formData.append("foot[]", footItem);
        }
        // if(others[foot + "Content"]){
        //     formData.append("foot[]", others[foot + "Content"]);
        // }
        for(const headItem of head){
            formData.append("head[]", headItem);
        }
        // if(others[head + "Content"]){
        //     formData.append("head[]", others[head + "Content"]);
        // }
        for(const gasDetectorItem of gasDetector){
            formData.append("gasDetector[]", gasDetectorItem);
        }
        // if(others[gasDetector + "Content"]){
        //     formData.append("gasDetector[]", others[gasDetector + "Content"]);
        // }
        for(const respiratoryProtectionItem of respiratoryProtection){
            formData.append("respiratoryProtection[]", respiratoryProtectionItem);
        }
        // if(others[respiratoryProtection + "Content"]){
        //     formData.append("respiratoryProtection[]", others[respiratoryProtection + "Content"]);
        // }
        for(const protectiveClothingItem of protectiveClothing){
            formData.append("protectiveClothing[]", protectiveClothingItem);
        }
        // if(others[protectiveClothing + "Content"]){
        //     formData.append("protectiveClothing[]", others[protectiveClothing + "Content"]);
        // }
        for(const hearingItem of hearing){
            formData.append("hearing[]", hearingItem);
        }
        // if(others[hearing + "Content"]){
        //     formData.append("hearing[]", others[hearing + "Content"]);
        // }
        for(const fallProtection of fallProtectionList){
            formData.append("fallProtectionList[]", fallProtection);
        }
        // if(others[fallProtectionList + "Content"]){
        //     formData.append("fallProtectionList[]", others[fallProtectionList + "Content"]);
        // }
        if(formHashKey) formData.append("helpers", JSON.stringify(helpers));
        formData.append("others", JSON.stringify(others));
        formData.append("sif", JSON.stringify(sif));
        formData.append("hazardControls", JSON.stringify(hazardControls));
        formData.append("jobSafetyAnalysisSign", JSON.stringify(picData));
        formData.append("jobSafetyAnalysisInternalSigns", JSON.stringify(internalPicDatas));
        formData.append("jobSafetyAnalysisSigns", JSON.stringify(picDatas));
        formData.append("sign", document.getElementById("esign").toDataURL());
        if(document.getElementById(`esignOut0`)){
            for(let ii = 0; ii < picDatas.length; ii++){
                formData.append("signs[]", document.getElementById(`esignOut${ii}`).toDataURL());
            }
        }
        if(internalPicDatas){
            for(let i = 0; i < internalPicDatas.length; i++){
                const canvas = document.getElementById(`esignIn${i}`);
                if(canvas){
                    formData.append("iSigns[]", canvas.toDataURL());
                }
            }
        }        
        //---------------------------------------------------
        setShowLoader(true);
        const jsaRes = await myAxios(
            formHashKey?
            "workLogs/mutiJSA.php":
            "workLogs/jsa_new.php", 
        formData);
        setShowLoader(false);
        if(!jsaRes) return;
        //--------------------------------------------------- 
        if(formHashKey){
            if(adminLink){
                setWorkInstructions(workInstructions => workInstructions.map(workInstruction => ({
                    ...workInstruction, 
                    workInstructionFiles: (
                        workInstruction.workInstructionHashKey === workInstructionHashKey?
                        jsaRes.data.workInstructionFiles:
                        workInstruction.workInstructionFiles
                    ), multiJSA: (
                        workInstruction.workInstructionHashKey === workInstructionHashKey?
                        jsaRes.data.multiJSA:
                        workInstruction.multiJSA
                    )
                })));
            }else{
                setWorkLogs(workLogs => workLogs.map(workLog => ({
                    ...workLog, 
                    workInstructionFiles:(
                        workLog.workLogHashKey === workLogHashKey?
                        jsaRes.data.workInstructionFiles:
                        workLog.workInstructionFiles
                    ), multiJSA:(
                        workLog.workLogHashKey === workLogHashKey?
                        jsaRes.data.multiJSA:
                        workLog.multiJSA
                    )
                })));
            }
        }else{
            if(adminLink){
                setWorkInstructions(workInstructions => workInstructions.map(workInstruction => ({
                    ...workInstruction, 
                    workInstructionFiles:(
                        workInstruction.workInstructionHashKey === workInstructionHashKey?
                        jsaRes.data[1]:
                        workInstruction.workInstructionFiles
                    ), jobSafetyAnalysisTemplate:(
                        workInstruction.workInstructionHashKey === workInstructionHashKey?
                        jsaRes.data[3]:
                        workInstruction.jobSafetyAnalysisTemplate
                    ), jobSafetyAnalysisTemplateDoc:(
                        workInstruction.workInstructionHashKey === workInstructionHashKey?
                        jsaRes.data[4]:
                        workInstruction.jobSafetyAnalysisTemplateDoc
                    ), jobSafetyAnalysisContent:(
                        workInstruction.workInstructionHashKey === workInstructionHashKey?
                        jsaRes.data[5]:
                        workInstruction.jobSafetyAnalysisContent
                    )
                })));
                setWorkLogs(workLogs => workLogs.map(w => ({
                    ...w, workLogFiles:(
                        w.workLogHashKey === workLogHashKey?
                        jsaRes.data[0]:
                        w.workLogFiles
                    ), jsaSubmitTime:(
                        w.workLogHashKey === workLogHashKey?
                        jsaRes.data[6]:
                        w.jsaSubmitTime
                    ), jobSafetyAnalysisSignId:(
                        w.workLogHashKey === workLogHashKey?
                        jsaRes.data[7]:
                        w.jobSafetyAnalysisSignId
                    )
                })));
            }else{
                setWorkLogs(workLogs => workLogs.map(w => ({
                    ...w, workLogFiles:(
                        w.workLogHashKey === workLogHashKey?
                        jsaRes.data[0]:
                        w.workLogFiles
                    ), workInstructionFiles:(
                        w.workLogHashKey === workLogHashKey?
                        jsaRes.data[1]:
                        w.workInstructionFiles
                    ), jobSafetyAnalysisTemplate:(
                        w.workLogHashKey === workLogHashKey?
                        jsaRes.data[3]:
                        w.jobSafetyAnalysisTemplate
                    ), jobSafetyAnalysisTemplateDoc:(
                        w.workLogHashKey === workLogHashKey?
                        jsaRes.data[4]:
                        w.jobSafetyAnalysisTemplateDoc
                    ), jobSafetyAnalysisContent:(
                        w.workLogHashKey === workLogHashKey?
                        jsaRes.data[5]:
                        w.jobSafetyAnalysisContent
                    ), jsaSubmitTime:(
                        w.workLogHashKey === workLogHashKey?
                        jsaRes.data[6]:
                        w.jsaSubmitTime
                    ), jobSafetyAnalysisSignId:(
                        w.workLogHashKey === workLogHashKey?
                        jsaRes.data[7]:
                        w.jobSafetyAnalysisSignId
                    )
                })));
            }
        }
        closeIt();
    }
 
    const handleFormSave = async e => {
        Object.entries(sif).map(([key, val]) => {
            if(val.selected && (Object.values(val.content).reduce(arrayReducer, []).length === 0 && val.inputControls === "")){
              window.alert(`No control for ${key}.`);
              return;
            }
        });
        const formData = new MyFormData(e);
        formData.append("workLogHashKey", workLogHashKey);
        if(formHashKey) formData.append("formHashKey", formHashKey);
        formData.append("forSave", "yes");
        for(const eyeFaceItem of eyeFace){
            formData.append("eyeFace[]", eyeFaceItem);
        }
        for(const handGlovesItem of handGloves){
            formData.append("handGloves[]", handGlovesItem);
        }
        for(const footItem of foot){
            formData.append("foot[]", footItem);
        }
        for(const headItem of head){
            formData.append("head[]", headItem);
        }
        for(const gasDetectorItem of gasDetector){
            formData.append("gasDetector[]", gasDetectorItem);
        }
        for(const respiratoryProtectionItem of respiratoryProtection){
            formData.append("respiratoryProtection[]", respiratoryProtectionItem);
        }
        for(const protectiveClothingItem of protectiveClothing){
            formData.append("protectiveClothing[]", protectiveClothingItem);
        }
        for(const hearingItem of hearing){
            formData.append("hearing[]", hearingItem);
        }
        for(const fallProtection of fallProtectionList){
            formData.append("fallProtectionList[]", fallProtection);
        }
        if(picData && picData.length){
            formData.append("jobSafetyAnalysisSign", JSON.stringify(picData));
        }
        if(picDatas && picDatas.length){
            formData.append("jobSafetyAnalysisSigns", JSON.stringify(picDatas));
        }
        if(internalPicDatas && internalPicDatas.length){
            formData.append("jobSafetyAnalysisInternalSigns", JSON.stringify(internalPicDatas));
        }
        if(formHashKey) formData.append("helpers", JSON.stringify(helpers));
        formData.append("others", JSON.stringify(others));
        formData.append("sif", JSON.stringify(sif));
        formData.append("hazardControls", JSON.stringify(hazardControls));
        //---------------------------------------------------
        setShowLoader(true);
        const jsaRes = await myAxios(
            formHashKey?
            "workLogs/mutiJSA.php":
            "workLogs/jsa_new.php", 
        formData);
        setShowLoader(false);
        if(!jsaRes) return;
        //---------------------------------------------------
        if(formHashKey){
            if(adminLink){
                setWorkInstructions(workInstructions => workInstructions.map(workInstruction => ({
                    ...workInstruction, 
                    workInstructionFiles:(
                        workInstruction.workInstructionHashKey === workInstructionHashKey?
                        jsaRes.data.workInstructionFiles:
                        workInstruction.workInstructionFiles
                    ), multiJSA:(
                        workInstruction.workInstructionHashKey === workInstructionHashKey?
                        jsaRes.data.multiJSA:
                        workInstruction.multiJSA
                    )
                })));
            }else{
                setWorkLogs(workLogs => workLogs.map(workLog => ({
                    ...workLog, 
                    workInstructionFiles:(
                        workLog.workLogHashKey === workLogHashKey?
                        jsaRes.data.workInstructionFiles:
                        workLog.workInstructionFiles
                    ), multiJSA:(
                        workLog.workLogHashKey === workLogHashKey?
                        jsaRes.data.multiJSA:
                        workLog.multiJSA
                    )
                })));
            }
        }else{
            if(adminLink){
                setWorkInstructions(workInstructions => workInstructions.map(workInstruction => ({
                    ...workInstruction, 
                    workInstructionFiles:(
                        workInstruction.workInstructionHashKey === workInstructionHashKey?
                        jsaRes.data[1]:
                        workInstruction.workInstructionFiles
                    ), jobSafetyAnalysisTemplate:(
                        workInstruction.workInstructionHashKey === workInstructionHashKey?
                        "":
                        workInstruction.jobSafetyAnalysisTemplate
                    ), jobSafetyAnalysisTemplateDoc:(
                        workInstruction.workInstructionHashKey === workInstructionHashKey?
                        "":
                        workInstruction.jobSafetyAnalysisTemplateDoc
                    ), jobSafetyAnalysisContent:(
                        workInstruction.workInstructionHashKey === workInstructionHashKey?
                        jsaRes.data[2]:
                        workInstruction.jobSafetyAnalysisContent
                    )
                })));
                setWorkLogs(workLogs => workLogs.map(w => ({
                    ...w, workLogFiles:(
                        w.workLogHashKey === workLogHashKey?
                        jsaRes.data[0]:
                        w.workLogFiles
                    ), jsaSaveTime:(
                        w.workLogHashKey === workLogHashKey?
                        jsaRes.data[3]:
                        w.jsaSaveTime
                    ), jsaSubmitTime:(
                        w.workLogHashKey === workLogHashKey?
                        "":
                        w.jsaSubmitTime
                    ), jobSafetyAnalysisSignId:(
                        w.workLogHashKey === workLogHashKey?
                        jsaRes.data[4]:
                        w.jobSafetyAnalysisSignId
                    )
                })));
            }else{
                setWorkLogs(workLogs => workLogs.map(w => ({
                    ...w, workLogFiles:(
                        w.workLogHashKey === workLogHashKey?
                        jsaRes.data[0]:
                        w.workLogFiles
                    ), workInstructionFiles:(
                        w.workLogHashKey === workLogHashKey?
                        jsaRes.data[1]:
                        w.workInstructionFiles
                    ), jobSafetyAnalysisContent:(
                        w.workLogHashKey === workLogHashKey?
                        jsaRes.data[2]:
                        w.jobSafetyAnalysisContent
                    ), jsaSaveTime:(
                        w.workLogHashKey === workLogHashKey?
                        jsaRes.data[3]:
                        w.jsaSaveTime
                    ), jsaSubmitTime:(
                        w.workLogHashKey === workLogHashKey?
                        defaultEmptyDateTime:
                        w.jsaSubmitTime
                    ), jobSafetyAnalysisSignId:(
                        w.workLogHashKey === workLogHashKey?
                        jsaRes.data[4]:
                        w.jobSafetyAnalysisSignId
                    )
                })));
            }
        }
        closeIt();
    }
    useEffect(() => {
        let isMounted = true;
        const getData = async() => {
            const formData = new MyFormData();
            formData.append("workLogHashKey", workLogHashKey);
            if(formHashKey) formData.append("formHashKey", formHashKey);
            formData.append("action", "Read");
            //---------------------------------------------------
            setShowLoader(true);
            const res =  await myAxios(
                formHashKey?
                "workLogs/mutiJSA.php":
                "workLogs/jsa_new.php", 
            formData);
            if(!isMounted) return;
            setShowLoader(false);
            if(!res) return;
            //---------------------------------------------------
            setInternalPicDatas(res.data.internalSigns);
            setPicData(JSON.parse(res.data.sign));
            setPicDatas(JSON.parse(res.data.signs));
            setPPE(res.data.sign.length > 0);
            if(formHashKey){
                setMainLaborCategory(res.data.laborCategory);
                setMainLaborName(res.data.laborName);
            }
        }
        getData();
        return () => {isMounted = false;}
    },[workLogHashKey])
    //--------------------------------------------------------------------------------------------
    return(
        <Modal
            closeIt = {closeIt}
            title = {formTitle}
            width = {1000}
            maxWidth = {"100%"}
            handleFormSubmit = {handleFormSubmit}
            actionKey = "Submit"
            onSave = {handleFormSave}
        >
            <div>
                <div className = "m-2">
                    opened at {realTime}
                </div>
                <h3 className = "my-4 text-danger">
                    <span className = "required-field"></span>This form must be completed prior to work start.
                </h3>
                <div className = "d-flex align-items-center blk5 mb-2">
                    <label className = "required-field text-nowrap">Bess Project Name:</label>
                    <input
                        type = "text"
                        className = "form-control flex-grow-1 w-100 ml-2"
                        readOnly
                        value = {projectName}
                    />
                </div>
                <div className = "d-flex align-items-center blk5 mb-2">
                    <label className = "required-field text-nowrap">Job Location:</label>
                    <input
                        required
                        type = "text"
                        className = "form-control flex-grow-1 w-100 ml-2"
                        name = "loc"
                        defaultValue = {location}
                    />
                </div>
                <div className = "d-flex align-items-center blk5 mb-2">
                    <label className = "required-field text-nowrap">Location of Nearest Medical Facility:</label>
                    <input
                        required
                        type = "text"
                        className = "form-control flex-grow-1 w-100 ml-2"
                        defaultValue = {curContent.loc2 || nearestMedicalFacility}
                        name = "loc2"
                    />
                </div>
                <div className = "d-flex align-items-center blk5 mb-2">
                    <label className = "required-field text-nowrap">Location of Nearest Evacuation Point:</label>
                    <input
                        required
                        type = "text"
                        className = "form-control flex-grow-1 w-100 ml-2"
                        defaultValue = {curContent.loc3}
                        name = "loc3"
                    />
                </div>
                <div className = "d-flex align-items-center blk5 mb-2">
                    <label className = "required-field text-nowrap">Location of Nearest Eyewash / Fire Extinguisher / First Aid:</label>
                    <input
                        required
                        type = "text"
                        className = "form-control flex-grow-1 w-100 ml-2"
                        defaultValue = {curContent.loc4}
                        name = "loc4"
                    />
                </div>
                <div className = "d-flex align-items-center blk5 mb-2">
                    <div className = "required-field">Valid USA Ticket?</div>
                    <label htmlFor = {`check1Yes`} className = "d-inline ml-3">Yes</label>
                    <input
                        type = "radio"
                        required = {true}
                        id = {`check1Yes`}
                        name = {"check1"}
                        defaultChecked = {curContent.check1 === "Yes"}
                        value = "Yes"
                        className = "checkboxSquare ml-2"
                    />
                    <label htmlFor = {`check1NA`} className = "d-inline ml-3">NA</label>
                    <input
                        type = "radio"
                        required = {true}
                        id = {`check1NA`}
                        name = {"check1"}
                        defaultChecked = {curContent.check1 === "NA"}
                        value = "NA"
                        className = "checkboxSquare ml-2"
                    />
                </div>
                <div className = "d-flex align-items-center blk5 mb-2">
                    <div className = "required-field">Have you controlled any potential water runoff for hydrovac excavation?</div>
                    <label htmlFor = {`sel1Yes`} className = "d-inline ml-3">Yes</label>
                    <input
                        type = "radio"
                        required = {true}
                        id = {`sel1Yes`}
                        name = {"sel1"}
                        checked = {curSel1 === "Yes"}
                        onChange = {e => setCurSel1(e.currentTarget.value)}
                        value = "Yes"
                        className = "checkboxSquare ml-2"
                    />
                    <label htmlFor = {`sel1No`} className = "d-inline ml-3">No</label>
                    <input
                        type = "radio"
                        required = {true}
                        id = {`sel1No`}
                        name = {"sel1"}
                        checked = {curSel1 === "No"}
                        onChange = {e => setCurSel1(e.currentTarget.value)}
                        value = "No"
                        className = "checkboxSquare ml-2"
                    />
                    <label htmlFor = {`sel1NA`} className = "d-inline ml-3">NA</label>
                    <input
                        type = "radio"
                        required = {true}
                        id = {`sel1NA`}
                        name = {"sel1"}
                        checked = {curSel1 === "NA"}
                        onChange = {e => setCurSel1(e.currentTarget.value)}
                        value = "NA"
                        className = "checkboxSquare ml-2"
                    />
                </div>
                {curSel1 === "No"?
                    <div className = "mb-3 text-danger font-weight-bold">Please submit an Equipment Damage Report for this ASAP.</div>
                    :<></>}
                <div className = "d-flex align-items-center blk5 mb-2">
                    <div className = "required-field">Have you examined the entire site for any potential hazards that could affect operations?</div>
                    <label htmlFor = {`sel2Yes`} className = "d-inline ml-3">Yes</label>
                    <input
                        type = "radio"
                        required = {true}
                        id = {`sel2Yes`}
                        name = {"sel2"}
                        defaultChecked = {curContent.sel2 === "Yes"}
                        value = "Yes"
                        className = "checkboxSquare ml-2"
                    />
                    <label htmlFor = {`sel2NA`} className = "d-inline ml-3">NA</label>
                    <input
                        type = "radio"
                        required = {true}
                        id = {`sel2NA`}
                        name = {"sel2"}
                        className = "checkboxSquare ml-2"
                        defaultChecked = {curContent.sel2 === "NA"}
                        value = "NA"
                    />
                </div>
                <div className = "d-flex align-items-center blk5 mb-2">
                    <div className = "required-field">Confined Space / Hot Work?</div>
                    <label htmlFor = {`sel3Yes`} className = "ml-3 d-inline">Yes</label>
                    <input
                        type = "radio"
                        required = {true}
                        id = {`sel3Yes`}
                        name = {"sel3"}
                        checked = {curConfinedWork === "Yes"}
                        onChange = {e => setConfinedWork(e.currentTarget.value)}
                        value = "Yes"
                        className = "checkboxSquare ml-2"
                    />
                    <label htmlFor = {`sel3NA`} className = "d-inline ml-3">NA</label>
                    <input
                        type = "radio"
                        required = {true}
                        id = {`sel3NA`}
                        name = {"sel3"}
                        checked = {curConfinedWork === "NA"}
                        onChange = {e => setConfinedWork(e.currentTarget.value)}
                        value = "NA"
                        className = "checkboxSquare ml-2"
                    />
                </div>
                {curConfinedWork === "Yes"?
                <>
                <h3 className = "mt-4">Confined Space / Hot Work</h3>
                {confinedSpaceHotWork.map((question , key) => 
                    <div key = {key} className = "d-flex align-items-center blk5 mb-2">
                        <div className = "required-field">{question}</div>
                        <label htmlFor = {`${confinedSpaceHotWorkNames[key]}yes`} className = "d-inline ml-3">Yes</label>
                        <input
                            type = "radio"
                            required = {true}
                            id = {`${confinedSpaceHotWorkNames[key]}yes`}
                            name = {confinedSpaceHotWorkNames[key]}
                            defaultChecked = {curContent[confinedSpaceHotWorkNames[key]] === "yes"}
                            value = "yes"
                            className = "checkboxSquare ml-2"
                        />
                        <label htmlFor = {`${confinedSpaceHotWorkNames[key]}no`} className = "d-inline ml-3">No</label>
                        <input
                            type = "radio"
                            required = {true}
                            id = {`${confinedSpaceHotWorkNames[key]}no`}
                            name = {confinedSpaceHotWorkNames[key]}
                            defaultChecked = {curContent[confinedSpaceHotWorkNames[key]] === "no"}
                            value = "no"
                            className = "checkboxSquare ml-2"
                        />
                    </div>
                )}
                </>
                :<></>}
            </div>
            {/************************************************/}
            <div className = "mb-4">
                <h3 className = "mt-4 mb-2">Potential Serious Injury & Fatality (SIF) Suggested Tailboard Topics</h3>
                <img src = {signimg} className = "d-block mx-auto"/>
                {sifList.map(item => 
                <div>
                    <h5 className = "d-flex align-items-center">
                        <label htmlFor = {`sifs${item.title}`} className = "d-inline">{item.title}</label>
                        <input
                            id = {`sifs${item.title}`}
                            type = "checkbox"
                            className = "checkboxSquare ml-2"
                            checked = {sif[item.title].selected}
                            onChange = {e => {
                                const checked = e.currentTarget.checked;
                                setSIF(sif => ({...sif, [item.title]: {...sif[item.title], selected: checked}}));
                            }}
                        />
                    </h5>
                    {sif[item.title].selected?
                    <div className = "mb-5">
                        <div className = "d-flex">
                            <label htmlFor = {`${item.title} Hazard`} className = "text-nowrap">Hazard</label>
                            <textarea
                                required
                                id = {`${item.title} Hazard`}
                                className = "form-control w-100 ml-2"
                                value = {sif[item.title].inputHazard}
                                onChange = {e => {
                                    const value = e.currentTarget.value;
                                    setSIF(sif => ({...sif, [item.title]: {...sif[item.title], inputHazard: value}}));
                                }}
                            />
                        </div>
                        {item.options.map(hazard => 
                        <div className = "d-flex align-items-center">
                            <img src = {hazard.img} className = "d-block"/>
                            <ul>
                                {hazard.options.map((control, controlIndex) => 
                                <li key = {controlIndex} className = "d-flex align-items-center my-2">
                                    <input
                                        id = {`sifs${hazard.title}${control}`}
                                        type = "checkbox"
                                        className = "checkboxSquare"
                                        checked = {sif[item.title].content[hazard.title].includes(control) || false}
                                        onChange = {e => {
                                            const checked = e.currentTarget.checked;
                                            if(checked){
                                                setSIF(sif => ({...sif, [item.title]: {...sif[item.title], 
                                                    content: {...sif[item.title].content, [hazard.title]: [...sif[item.title].content[hazard.title], control]}}})
                                                );
                                            }else{
                                                setSIF(sif => ({...sif, [item.title]: {...sif[item.title], 
                                                    content: {...sif[item.title].content, [hazard.title]: sif[item.title].content[hazard.title].filter(ctl => ctl !== control)}}})
                                                );
                                            }
                                        }}
                                    />
                                    <label htmlFor = {`sifs${hazard.title}${control}`} className = "d-inline ml-3">{control}</label>
                                </li>)}
                            </ul>
                        </div>)}
                        <div className = "d-flex">
                            <label htmlFor = {`${item.title} Other Controls`} className = "text-nowrap">Other Controls</label>
                            <textarea
                                id = {`${item.title} Other Controls`}
                                className = "form-control w-100 ml-2"
                                value = {sif[item.title].inputControls}
                                onChange = {e => {
                                    const value = e.currentTarget.value;
                                    setSIF(sif => ({...sif, [item.title]: {...sif[item.title], inputControls: value}}));
                                }}
                            />
                        </div>
                    </div>
                    :<></>}
                </div>
                )}
            </div>
            {/************************************************/}
            <h3 className = "mt-4 mb-2">Secondary Hazard Control</h3>
            {hazardControls.map((hazardControl, key) => 
            <div key = {key}>
            <h5 className = "mb-2">Hazard {key + 1}</h5>
            <div>
                <div className = "required-field mb-2">Hazard:</div>
                {[
                    [0, 5], 
                    [5, 10], 
                    [10, 15], 
                    [15, 20], 
                    [20]
                ].map((sliced, slicedIndex, self) => 
                <div className = "d-flex align-items-center blk5 mb-2">
                    {hazardControlData.slice(...sliced).map((option, k) => <div className = "d-flex align-items-center mb-2" key = {k}>
                    <input
                        type = "radio"
                        required = {true}
                        name = {`hazardControlHazard${key}`}
                        id = {`hazardControlHazard${key}${option}`}
                        checked = {hazardControl.hazard === option}
                        onChange = {() => {
                            setHazardControls([
                                ...hazardControls.slice(0, key), 
                                {...hazardControl, 
                                    hazard: option,
                                    others: false
                                }, 
                                ...hazardControls.slice(key + 1)]
                            );
                        }}
                        className = {`checkboxSquare${k === 0?"":" ml-3"}`}
                    />
                    <label htmlFor = {`hazardControlHazard${key}${option}`} className = "d-inline ml-2">{option}</label>
                    </div>)}
                    {slicedIndex === self.length - 1?<>
                    <div className = "d-flex align-items-center mb-2">
                        <input
                            type = "radio"
                            required = {true}
                            name = {`hazardControlHazard${key}`}
                            id = {`hazardControlHazard${key}Others`}
                            checked = {hazardControl.hazard === "Others"}
                            onChange = {() => {
                                setHazardControls([
                                    ...hazardControls.slice(0, key), 
                                    {...hazardControl, 
                                        hazard: "Others",
                                        others: true
                                    }, 
                                    ...hazardControls.slice(key + 1)]
                                );
                            }}
                            className = {`checkboxSquare${hazardControlData.slice(...self[self.length - 1]).length === 0?"":" ml-3"}`}
                        />
                        <label htmlFor = {`hazardControlHazard${key}Others`} className = "d-inline ml-2">Others</label>
                    </div>
                    {hazardControl.others?
                    <input
                        placeholder = "Please specify"
                        required = {true}
                        className = "form-control"
                        value = {hazardControl.otherHazard}
                        onChange = {e => {
                            setHazardControls([
                                ...hazardControls.slice(0, key), 
                                {...hazardControl, 
                                    otherHazard: e.currentTarget.value
                                }, 
                                ...hazardControls.slice(key + 1)]
                            );
                        }}
                    />:null}
                    </>:<></>}
                </div>)}
            </div>
            <div className = "d-flex align-items-center blk5 mb-2">
                <label className = "required-field text-nowrap">Control</label>
                <textarea
                    required = {true}
                    className = "form-control w-100 ml-2"
                    rows = {4}
                    value = {hazardControl.control}
                    onChange = {e => {
                        setHazardControls([
                            ...hazardControls.slice(0, key), 
                            {...hazardControl, 
                                control: e.currentTarget.value
                            }, 
                            ...hazardControls.slice(key + 1)]
                        );
                    }}
                />
            </div>
            <span
                className = "btn btn-danger"
                onClick = {() => {
                    setHazardControls([...hazardControls.slice(0, key), ...hazardControls.slice(key + 1)]);
                }}
            >
                Delete Hazard
            </span>
            </div>)}
            <div className = "my-3">
                <span
                    className = "btn btn-primary"
                    onClick = {() => {
                        setHazardControls([...hazardControls, {hazard: "", others: false, otherHazard:"", control: ""}]);
                    }}
                >
                    Add Hazard
                </span>
            </div>
            {/************************************************/}
            <h3 className = "mt-4 mb-2">PPE Checklist - Check all that apply</h3> 
            <h5 className = "mb-2">Eye & Face</h5>
            {[
                [0, 5], 
                [5]
            ].map((sliced, slicedIndex, self) => 
            <div key = {slicedIndex} className = "d-flex align-items-center blk5 mb-2">
                {faceData.slice(...sliced).map((option, key) => (
                <div key = {key} className = "d-flex align-items-center mb-2">
                    <input
                        id = {`eyeFace${key}${option}`}
                        type = "checkbox"
                        className = {`checkboxSquare${key === 0?"":" ml-3"}`}
                        value = {option}
                        checked = {eyeFace.includes(option)}
                        onChange = {e => {
                            const checked = e.currentTarget.checked;
                            if(checked){
                                setEyeFace([...eyeFace, option].filter(onlyUnique));
                            }else{
                                setEyeFace(eyeFace.filter(opt => opt !== option));
                            }
                        }}
                    />
                    <label htmlFor = {`eyeFace${key}${option}`} className = "ml-2">{option}</label>
                </div>
                ))}
                {slicedIndex === self.length - 1?<>
                <OtherStyle key = {1} before = {faceData.slice(...self[self.length - 1]).length !== 0} title = "eyeFace" others = {others} setOthers = {setOthers}/>
                </>:<></>}
            </div>)}
            <h5 className = "mb-2">Hand Gloves</h5>
            {[
                [0, 6], 
                [6]
            ].map((sliced, slicedIndex, self) => 
            <div key = {slicedIndex} className = "d-flex align-items-center blk5 mb-2"> 
                {handData.slice(...sliced).map((option, key) => (
                <div key = {key} className = "d-flex align-items-center mb-2">
                    <input
                        id = {`handGloves${key}${option}`}
                        type = "checkbox"
                        className = {`checkboxSquare ${key === 0?"":" ml-3"}`}
                        value = {option}
                        checked = {handGloves.includes(option)}
                        onChange = {e => {
                            const checked = e.currentTarget.checked;
                            if(checked){
                                setHandGloves([...handGloves, option].filter(onlyUnique));
                            }else{
                                setHandGloves(handGloves.filter(opt => opt !== option));
                            }
                        }}
                    />
                    <label htmlFor = {`handGloves${key}${option}`} className = "ml-2">{option}</label>
                </div>
                ))}
                {slicedIndex === self.length - 1?<>
                <OtherStyle key = {2} before = {handData.slice(...self[self.length - 1]).length !== 0} title = "handGloves" others = {others} setOthers = {setOthers}/>
                </>:<></>}
            </div>)}
            <h5 className = "mb-2">Foot</h5>
            {[
                [0, 6], 
                [6]
            ].map((sliced, slicedIndex, self) => 
            <div key = {slicedIndex} className = "d-flex align-items-center blk5 mb-2"> 
                {footData.slice(...sliced).map((option, key) => (
                <div key = {key} className = "d-flex align-items-center mb-2">
                    <input
                        id = {`foot${key}${option}`}
                        type = "checkbox"
                        className = {`checkboxSquare ${key === 0?"":" ml-3"}`}
                        value = {option}
                        checked = {foot.includes(option)}
                        onChange = {e => {
                            const checked = e.currentTarget.checked;
                            if(checked){
                                setFoot([...foot, option].filter(onlyUnique));
                            }else{
                                setFoot(foot.filter(opt => opt !== option));
                            }
                        }}
                    />
                    <label htmlFor = {`foot${key}${option}`} className = "ml-2">{option}</label>
                </div>
                ))}
                {slicedIndex === self.length - 1?<>
                <OtherStyle key = {3} before = {footData.slice(...self[self.length - 1]).length !== 0} title = "foot" others = {others} setOthers = {setOthers}/>
                </>:<></>}
            </div>)}
            <h5 className = "mb-2">Head</h5>
            {[
                [0]
            ].map((sliced, slicedIndex, self) => 
            <div key = {slicedIndex} className = "d-flex align-items-center blk5 mb-2"> 
                {headData.slice(...sliced).map((option, key) => (
                <div key = {key} className = "d-flex align-items-center mb-2">
                    <input
                        id = {`head${key}${option}`}
                        type = "checkbox"
                        className = {`checkboxSquare ${key === 0?"":" ml-3"}`}
                        value = {option}
                        checked = {head.includes(option)}
                        onChange = {e => {
                            const checked = e.currentTarget.checked;
                            if(checked){
                                setHead([...head, option].filter(onlyUnique));
                            }else{
                                setHead(head.filter(opt => opt !== option));
                            }
                        }}
                    />
                    <label htmlFor = {`head${key}${option}`} className = "ml-2">{option}</label>
                </div>
                ))}
                {slicedIndex === self.length - 1?<>
                <OtherStyle key = {4} before = {headData.slice(...self[self.length - 1]).length !== 0} title = "head" others = {others} setOthers = {setOthers}/>
                </>:<></>}
            </div>)}
            <h5 className = "mb-2">Gas Detector</h5>
            {[
                [0]
            ].map((sliced, slicedIndex, self) =>
            <div key = {slicedIndex} className = "d-flex align-items-center blk5 mb-2"> 
                {gasDetectorData.slice(...sliced).map((option, key) => (
                <div key = {key} className = "d-flex align-items-center mb-2">
                    <input
                        id = {`gasDetector${key}${option}`}
                        type = "checkbox"
                        className = {`checkboxSquare ${key === 0?"":" ml-3"}`}
                        value = {option}
                        checked = {gasDetector.includes(option)}
                        onChange = {e => {
                            const checked = e.currentTarget.checked;
                            if(checked){
                                setGasDetector([...gasDetector, option].filter(onlyUnique));
                            }else{
                                setGasDetector(gasDetector.filter(opt => opt !== option));
                            }
                        }}
                    />
                    <label htmlFor = {`gasDetector${key}${option}`} className = "ml-2">{option}</label>
                </div>
                ))}
                {slicedIndex === self.length - 1?<>
                <OtherStyle key = {5} before = {gasDetectorData.slice(...self[self.length - 1]).length !== 0} title = "gasDetector" others = {others} setOthers = {setOthers}/>
                </>:<></>}
            </div>)}
            <h5 className = "mb-2">Respiratory Protection</h5>
            {[
                [0, 4], 
                [4]
            ].map((sliced, slicedIndex, self) =>
            <div key = {slicedIndex} className = "d-flex align-items-center blk5 mb-2"> 
                {respiratoryProtectionData.slice(...sliced).map((option, key) => (
                <div key = {key} className = "d-flex align-items-center mb-2">
                    <input
                        id = {`respiratoryProtection${key}${option}`}
                        type = "checkbox"
                        className = {`checkboxSquare ${key === 0?"":" ml-3"}`}
                        value = {option}
                        checked = {respiratoryProtection.includes(option)}
                        onChange = {e => {
                            const checked = e.currentTarget.checked;
                            if(checked){
                                setRespiratoryProtection([...respiratoryProtection, option].filter(onlyUnique));
                            }else{
                                setRespiratoryProtection(respiratoryProtection.filter(opt => opt !== option));
                            }
                        }}
                    />
                    <label htmlFor = {`respiratoryProtection${key}${option}`} className = "ml-2">{option}</label>
                </div>
                ))}
                {slicedIndex === self.length - 1?<>
                <OtherStyle key = {6} before = {respiratoryProtectionData.slice(...self[self.length - 1]).length !== 0} title = "respiratoryProtection" others = {others} setOthers = {setOthers}/>
                </>:<></>}
            </div>)}
            <h5 className = "mb-2">Protective Clothing</h5>
            {[
                [0]
            ].map((sliced, slicedIndex, self) =>
            <div key = {slicedIndex} className = "d-flex align-items-center blk5 mb-2"> 
                {protectiveClothingData.slice(...sliced).map((option, key) => (
                <div key = {key} className = "d-flex align-items-center mb-2">
                    <input
                        id = {`protectiveClothing${key}${option}`}
                        type = "checkbox"
                        className = {`checkboxSquare ${key === 0?"":" ml-3"}`}
                        value = {option}
                        checked = {protectiveClothing.includes(option)}
                        onChange = {e => {
                            const checked = e.currentTarget.checked;
                            if(checked){
                                setProtectiveClothing([...protectiveClothing, option].filter(onlyUnique));
                            }else{
                                setProtectiveClothing(protectiveClothing.filter(opt => opt !== option));
                            }
                        }}
                    />
                    <label htmlFor = {`protectiveClothing${key}${option}`} className = "ml-2">{option}</label>
                </div>
                ))}
                {slicedIndex === self.length - 1?<>
                <OtherStyle key = {7} before = {protectiveClothingData.slice(...self[self.length - 1]).length !== 0} title = "protectiveClothing" others = {others} setOthers = {setOthers}/>
                </>:<></>}
            </div>)}
            <h5 className = "mb-2">Hearing</h5>
            {[
                [0]
            ].map((sliced, slicedIndex, self) =>
            <div key = {slicedIndex} className = "d-flex align-items-center blk5 mb-2"> 
                {hearingData.slice(...sliced).map((option, key) => (
                <div key = {key} className = "d-flex align-items-center mb-2">
                    <input
                        id = {`hearing${key}${option}`}
                        type = "checkbox"
                        className = {`checkboxSquare ${key === 0?"":" ml-3"}`}
                        value = {option}
                        checked = {hearing.includes(option)}
                        onChange = {e => {
                            const checked = e.currentTarget.checked;
                            if(checked){
                                setHearing([...hearing, option].filter(onlyUnique));
                            }else{
                                setHearing(hearing.filter(opt => opt !== option));
                            }
                        }}
                    />
                    <label htmlFor = {`hearing${key}${option}`} className = "ml-2">{option}</label>
                </div>
                ))}
                {slicedIndex === self.length - 1?<>
                <OtherStyle key = {8} before = {hearingData.slice(...self[self.length - 1]).length !== 0} title = "hearing" others = {others} setOthers = {setOthers}/>
                </>:<></>}
            </div>)}
            <h5 className = "mb-2">Fall Protection</h5>
            {[
                [0]
            ].map((sliced, slicedIndex, self) =>
            <div key = {slicedIndex} className = "d-flex align-items-center blk5 mb-2"> 
                {fallProtectionData.slice(...sliced).map((option, key) => (
                <div key = {key} className = "d-flex align-items-center mb-2">
                    <input
                        id = {`fallProtectionList${key}${option}`}
                        type = "checkbox"
                        className = {`checkboxSquare ${key === 0?"":" ml-3"}`}
                        value = {option}
                        checked = {fallProtectionList.includes(option)}
                        onChange = {e => {
                            const checked = e.currentTarget.checked;
                            if(checked){
                                setFallProtectionList([...fallProtectionList, option].filter(onlyUnique));
                            }else{
                                setFallProtectionList(fallProtectionList.filter(opt => opt !== option));
                            }
                        }}
                    />
                    <label htmlFor = {`fallProtectionList${key}${option}`} className = "ml-2">{option}</label>
                </div>
                ))}
                {slicedIndex === self.length - 1?<>
                <OtherStyle key = {9} before = {fallProtectionData.slice(...self[self.length - 1]).length !== 0} title = "fallProtectionList" others = {others} setOthers = {setOthers}/>
                </>:<></>}
            </div>)}
            {/************************************************/}
            <h5 className = "mb-2">List additional PPE</h5> 
            <div className = "mb-2">
                <textarea
                    rows = {4}
                    className = "form-control w-100"
                    name = "additionalPPE"
                    defaultValue = {curContent.additionalPPE}
                />
            </div>
            <div className = "mt-3 mb-1 text-danger font-weight-bold">If conditions change, STOP THE JOB, seek advice, including discussion on new hazards and identification of controls, and update this section of the JSA with time of change and additional hazards and controls. Document personnel included in the tailboard update.</div>
            <h5 className = "mb-2">Job Scope change / Additional Hazard / Notes</h5> 
            <div className = "mb-2">
                <textarea
                    rows = {4}
                    className = "form-control w-100"
                    name = "notes"
                    defaultValue = {curContent.notes}
                />
            </div>
            <ul className = "text-danger font-weight-bold">
                <li>Assign roles responsibilities in case of an accident, emergency or abnormal condition. In the event of serious injury or fatality call 911, and make the area safe. As soon as it is safe to do so, call the safety manager with information about the emergency and call the supervisor.</li>
                <li>Verify that crew members know their own and other crew members' tasks and roles.</li>
                <li>All employees have the right, authority, obligation and responsibility to STOP THE JOB if an imminent hazard or serious perceived danger exists. Stop the job, notify the Person in Charge (PIC), investigate/evaluate, correct unsafe situations and resume when safe.</li>
            </ul>
            <div className = "border rounded mb-2 p-3">
                <div className = "d-flex align-items-center blk5 mb-2">
                    <label className = "required-field">Name:</label>
                    <input
                        type = "text"
                        className = "form-control ml-2"
                        value = {formHashKey?mainLaborName:(userName || user.userName)}
                        name = "memberName"
                        readOnly
                    />
                    <label className = "required-field ml-2">Role:</label>
                    <input
                        type = "text"
                        className = "form-control ml-2"
                        value = {formHashKey?mainLaborCategory:laborCategory}
                        readOnly
                    />
                    <label className = "required-field ml-2">Date:</label>
                    <input
                        type = "text"
                        className = "form-control ml-2"
                        defaultValue = {(new MyDate()).s()}
                        name = "submitDate"
                        readOnly
                    />
                </div>
                <label htmlFor = "signPPE" className = "font-weight-bold inline">My PPE is in a condition to effectively protect against hazards.</label>
                <input
                    type = "radio"
                    id = {"signPPE"}
                    checked = {ppe}
                    onChange = {() => setPPE(true)}
                    className = "checkboxSquare ml-3"
                />
                {ppe?
                <Esign
                    buttonClassName = "my-2"
                    picData = {picData}
                    setPicData = {setPicData}
                />
                :<></>}
            </div>
            {internalPicDatas.map((x, xi) => 
            <div key = {xi} className = "border rounded mb-2 p-3">
                <div className = "d-flex align-items-center blk5 mb-2">
                    <label className = "required-field">Name:</label>
                    <input
                        type = "text"
                        className = "form-control ml-2"
                        value = {x.laborName}
                        readOnly
                    />
                    <label className = "required-field ml-2">Role:</label>
                    <input
                        type = "text"
                        className = "form-control ml-2"
                        value = {x.laborCategory}
                        readOnly
                    />
                    <label className = "required-field ml-2">Date:</label>
                    <input
                        type = "text"
                        className = "form-control ml-2"
                        value = {(new MyDate()).s()}
                        readOnly
                    />
                </div>
                {formHashKey?
                <div className = "d-flex my-3">
                    <label className = "h5 inline">Include in this Form</label>
                    <input
                        type = "checkbox"
                        className = "checkboxSquare ml-2"
                        checked = {helpers[x.workLogHashKey] !== undefined}
                        onChange = {e => {
                            if(e.currentTarget.checked){
                                setHelpers(helpers => ({...helpers, [x.workLogHashKey]: ""}));
                            }else{
                                if(![undefined, ""].includes(helpers[x.workLogHashKey]) && !window.confirm("Are you sure to delete this sign?")) return;
                                const temp = {...helpers};
                                delete(temp[x.workLogHashKey]);
                                setHelpers(temp);
                            }
                        }}
                    />
                 </div>
                 :<></>}
                {!formHashKey || helpers[x.workLogHashKey] !== undefined?<p>
                <label htmlFor = {`signPPF${xi}`} className = "font-weight-bold inline">My PPE is in a condition to effectively protect against hazards.</label>
                <input
                    type = "radio"
                    id = {`signPPF${xi}`}
                    checked = {x.ppe === "yes"}
                    onChange = {() => {
                        setInternalPicDatas(internalPicDatas => internalPicDatas.map((internalPicData, i) => xi === i?({
                            ...internalPicData,
                            ppe: "yes"
                        }):internalPicData));
                    }}
                    className = "checkboxSquare ml-3"
                />
                {x.ppe === "yes"?
                <Esigns
                    buttonClassName = "my-3"
                    signIndex = {xi}
                    id = {`In${xi}`}
                    picDatas = {internalPicDatas} 
                    setPicDatas = {setInternalPicDatas}
                    prefix = {`Internal`} 
                    disableDefaultSign
                />
                :<></>}
                </p>
                :<></>}
            </div>
            )}
            {picDatas.map((x, xi) => 
            <div key = {xi} className = "border rounded mb-2 p-3">
                <div className = "d-flex align-items-center blk5 mb-2">
                    <label className = "required-field">Name:</label>
                    <input
                        type = "text"
                        className = "form-control ml-2"
                        required
                        value = {x.name}
                        onChange = {e => {
                            setPicDatas([...picDatas.slice(0, xi),{...picDatas[xi], name: e.currentTarget.value},...picDatas.slice(xi + 1)]);
                        }}
                    />
                    <label className = "required-field ml-2">Role:</label>
                    <input
                        type = "text"
                        className = "form-control ml-2"
                        required
                        value = {x.role}
                        onChange = {e => {
                            setPicDatas([...picDatas.slice(0, xi),{...picDatas[xi], role: e.currentTarget.value},...picDatas.slice(xi + 1)]);
                        }}
                    />
                    <label className = "required-field ml-2">Date:</label>
                    <input
                        type = "date"
                        min = "1900-01-01"
                        max = "2999-12-31"
                        required
                        className = "form-control ml-2"
                        value = {x.date}
                        onChange = {e => setPicDatas([
                            ...picDatas.slice(0, xi),
                            {
                                ...picDatas[xi], 
                                date: e.currentTarget.value
                            },
                            ...picDatas.slice(xi + 1)
                        ])}
                    />
                </div>
                <Esigns 
                    buttonClassName = "my-3"
                    signIndex = {xi}
                    id = {`Out${xi}`}
                    picDatas = {picDatas} 
                    setPicDatas = {setPicDatas}
                    prefix = {`Customer`} 
                    disableDefaultSign
                />
                <span className = "btn btn-danger" onClick = {() => {
                    setPicDatas([...picDatas.slice(0, xi),...picDatas.slice(xi + 1)]);
                }}>Delete This Signature</span>
            </div>
            )}
            <span className = "btn btn-primary mb-2" onClick = {e => {
                setPicDatas([...picDatas, {data:[], name: "", date: "", role: ""}]);
            }}>Add Signature</span>
            <ul className = "my-2 text-danger font-weight-bold @text-uppercase">
                <li>If injury occurred, Immediately report the incident, injury, event or issue to the site superintendent or safety representative. </li>
                <li>In case of an incident, the following safety reps will be contacted: 
                    <ul>
                    {jsaManagers.map((jsaManager, jsaManagerIndex) => <li key = {jsaManagerIndex}><UserInfo name = {jsaManager.name} email = {jsaManager.email}/> <a href = {"tel:+1" + jsaManager.tel.replace(/-/g, "")}>{jsaManager.tel}</a></li>)}
                    </ul>
                </li>
                <li>Nurse on Call:&nbsp;
                    {jsaOnsiteNumbers.map((jsaOnsiteNumber, jsaOnsiteNumberIndex) => <a key = {jsaOnsiteNumberIndex} href = {"tel:+1" + jsaOnsiteNumber.replace(/-/g, "")}>{jsaOnsiteNumber}</a>)}
                </li>
            </ul>
        </Modal>
    )    
}